import Tooltip from "@/tooltip";
import BuddySelector from "@/components/common/custom-selectors/BuddySelector";
import { useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as INTEGRATION_ACTIONS } from '../../../store/actions/integrationActions';
import { Actions as BAMBOO_ACTIONS } from './store/bambooActions';

const BambooEmployeeLink = ({
    thirdPartyList,
    getBambooEmployees,
    thirdPartyId,
    disabled,
    switchEmployeeLink
}) => {

    useEffect(() => {
        if (!thirdPartyList) getBambooEmployees()
    }, [])

    return (
        <>
            <div className="col-lg-3 col-sm-3">
                <div className="form-material form-container">
                    <label htmlFor="material-text">
                        <Tooltip content="The employee reference code is used when synchronising with third party software">
                            Bamboo HR Link
                        </Tooltip>
                    </label>
                    <BuddySelector
                        isDisabled={disabled}
                        name="thirdPartyLink"
                        options={thirdPartyList}
                        value={thirdPartyList?.find(item => item.value == thirdPartyId)}
                        isClearable={true}
                        onChange={(selected) => {
                            switchEmployeeLink(selected?.value || 'desynced')
                        }}
                    />
                </div>
            </div>
        </>
    )
}


const mapStateToProps = (state, ownProps) => {
    const agreementInfo = ownProps.agreementInfo ? ownProps.agreementInfo : state.employee.agreementInfo;

    const thirdPartyList = state.integration.hris?.bambooHr?.employees?.map?.(e => ({
        label: `${e.firstName} ${e.lastName}`,
        value: e.id,
    }))
    const thirdPartyId = state.employee?.bambooHrLink || state?.integration.hris?.bambooHr?.links?.find?.(e => e?.agreement == agreementInfo?.id)?.link

    return {
        agreementInfo,
        thirdPartyList,
        thirdPartyId,
    }
}

const mapDispatchToProps = dispatch => ({
    getBambooEmployees: () => dispatch(BAMBOO_ACTIONS.getBambooEmployees()),
    switchEmployeeLink: (employee) => dispatch(INTEGRATION_ACTIONS.switchEmployeeLink(employee, 'bambooHr')),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BambooEmployeeLink)